<template lang="pug">
dv-text-field(
  v-bind="attrs"
  v-on="listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(
      :name="name"
      v-bind="data"
    )
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
import DvTextField from './DvTextField.vue';

export default {
  components: {
    DvTextField,
  },
  props: {
    iconOn: {
      type: String,
      default: '$ui-eye-slash',
    },
    iconOff: {
      type: String,
      default: '$ui-eye',
    },
  },
  data() {
    return {
      showRawPassword: false,
    };
  },
  computed: {
    attrs() {
      const { type, ...rest } = this.$attrs;
      const passwordAttrs = this.showRawPassword ? this.showRawPasswordAttrs : this.hideRawPasswordAttrs;

      return {
        ...passwordAttrs,
        ...rest,
      };
    },
    listeners() {
      return {
        ...this.$listeners,
        'click:append': this.onClickAppend,
      };
    },
    showRawPasswordAttrs() {
      return {
        type: 'text',
        'append-icon': this.iconOn,
      };
    },
    hideRawPasswordAttrs() {
      return {
        type: 'password',
        'append-icon': this.iconOff,
      };
    },
  },
  watch: {},
  created() {},
  methods: {
    onClickAppend() {
      this.showRawPassword = !this.showRawPassword;
      this.$emit('click:append');
    },
  },
};
</script>
